import * as React from 'react';


export default class Edit extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
       <g id="exzeo_2.x_icon_set" fillRule="evenodd" transform="translate(-196.000000, -180.000000)">
            <g id="Group-57" transform="translate(196.000000, 180.000000)">
                <g id="Page-1" transform="translate(1.000000, 1.000000)">
                    <path d="M12.1599265,7.35082353 L12.1599265,12.7210588 C12.1599265,13.1237647 11.8541912,13.4498824 11.4758824,13.4498824 L1.07007353,13.4498824 C0.691764706,13.4498824 0.386029412,13.1237647 0.386029412,12.7210588 L0.386029412,1.92952941 C0.386029412,1.55482353 0.670919118,1.25176471 1.02143382,1.25176471 L6.27297794,1.25176471" id="Stroke-1" className="ttController"></path>
                    <path d="M12.7842132,2.25844706 L6.40469118,9.06327059 C6.39388235,9.0748 6.37998529,9.08468235 6.36454412,9.08962353 L4.51623529,9.75997647 C4.44057353,9.78797647 4.36568382,9.7188 4.37958088,9.6348 L4.75943382,7.38574118 C4.76329412,7.36268235 4.77333088,7.34209412 4.78877206,7.32562353 L11.1613456,0.527388235 C11.3064926,0.373388235 11.5419706,0.373388235 11.6863456,0.527388235 L12.7842132,1.69844706 C12.9285882,1.85327059 12.9285882,2.10444706 12.7842132,2.25844706 Z" id="Stroke-3" className="ttController"></path>
                </g>
            </g>
        </g>
      </svg>
    )
  }
}
